export enum IconPosition {
  LEFT = 'left',
  NONE = 'none',
  RIGHT = 'right',
}
